import { isBrowser } from 'motion/react';
import { startTransition, useEffect, useState } from 'react';

export const useIdleLoad = (isIntersecting: boolean) => {
  const [shouldLoad, setShouldLoad] = useState<boolean>(false);

  useEffect(() => {
    if (isIntersecting && isBrowser) {
      let idleId: number | NodeJS.Timeout | null = null;
      let scheduled = false;

      const trySchedule = () => {
        if (scheduled) {
          return;
        }

        scheduled = true;

        if ('requestIdleCallback' in window) {
          idleId = window.requestIdleCallback(onIdle);
        } else {
          idleId = setTimeout(onIdle, 200);
        }
      };

      const onIdle = (deadline?: IdleDeadline) => {
        const canRun =
          !deadline || deadline.timeRemaining() > 5 || deadline.didTimeout;

        if (canRun) {
          startTransition(() => setShouldLoad(true));
        } else {
          scheduled = false;
          trySchedule();
        }
      };

      const onVisibility = () => {
        if (document.visibilityState === 'visible') {
          trySchedule();
        }
      };

      document.addEventListener('visibilitychange', onVisibility);

      trySchedule();

      return () => {
        if (idleId !== null) {
          if ('cancelIdleCallback' in window) {
            window.cancelIdleCallback(idleId as number);
          } else {
            clearTimeout(idleId);
          }
        }

        document.removeEventListener('visibilitychange', onVisibility);
      };
    }
  }, [isIntersecting, setShouldLoad]);

  return shouldLoad;
};
